import {
  stringify as stringifyQs,
  parse as parseQs,
} from 'query-string'

const ARRAY_FORMAT = 'bracket'

export const STRINGIFY_OPTIONS = {
  arrayFormat: ARRAY_FORMAT,
}

export const PARSE_OPTIONS = {
  arrayFormat: ARRAY_FORMAT,
}

/**
 * Create a url string given a query object
 * @param {Object} query The query data
 * @param {Object} stringifyOptions The stringify options
 * @returns {String} A string which can be used in a url
 */
export function stringify (query, stringifyOptions = STRINGIFY_OPTIONS) {
  return stringifyQs(query, stringifyOptions)
}

/**
 * Parse a URL for a query string
 * @param {String} url The url to parse
 */
export function parse (url) {
  try {
    return parseQs(url, PARSE_OPTIONS)
  } catch (e) {
    if (!(e instanceof URIError)) {
      throw e
    }
  }
  return {}
}
